import React, { Component } from 'react';
import {Container, Image, Col, Button} from 'react-bootstrap';

class PartnerProgram extends Component {
  render() {
    return (
      <Container className="nopadding">
      <Container className="tileContainer" >
      <Container className="tileWide">
        <Container className="tileHeader"> Partner program</Container>
        
        <Container className="tileBody">
          <p> We are pleased to announce that UMAAV is a partner of <a href="https://www.bankofmelbourne.com.au/" target="_blank">Bank of Melbourne (BOM) Loan Referral Scheme</a>.</p> 
          
          <p> BOM offer market leading rates for new / refinance home loan customers. </p>
          <p> With your every new / refinanced loan, UMAAV scholarship program will earn a monetary reward.</p>
          <p> This has no additional cost to you.</p>
          <p> As a UMAAV member please consider BOM for your next home loan or refinance needs.</p>
          <p> Please contact,<br/>Mr. Kuma Munasinghe (UMAAV): <br/><a href="tel:0425337093">0425337093</a></p>
       
        </Container>
      </Container>
    </Container>
    </Container>
    );
  }
}

export default PartnerProgram;
